import { ComponentsOverrides, Theme } from '@mui/material';

const titleStyleOverrides: ComponentsOverrides<Theme>['MuiDialogTitle'] = {
  root: {},
};

export const MuiDialogTitle = {
  styleOverrides: titleStyleOverrides,
};
